import { createLucideIcon } from 'lucide-react';

export const CircleProgressSolid = createLucideIcon('CircleProgressSolid', [
  [
    'path',
    {
      key: 'path-1',
      d: 'M13 1A11 11 0 1 1 1.2 12H13z',
      fill: 'currentColor',
      stroke: 'none',
    },
  ],
]);
